import { useEffect, useState, useMemo, useCallback, useRef } from "react";
import useEsri from "./useEsri";
import { APP_SETTINGS, QUERY_DATA_BUTTON_ACTION } from "../settings";

const { ZONE_URL, LA_URL } = APP_SETTINGS.GIS_SERVER;

const useNavigateZoomToZoneLaPopup = ({
  onZoneLaListFieldChange,
  onQueryLayerFieldChange,
  getSelectedQueryLayer,
}) => {
  const [zoneLaUniqueCode, setZoneLaUniqueCode] = useState(null);
  const { navigateAndDisplayPopup, clearPopup, triggerPopupActions } =
    useEsri();
  const activeQueryLayer = useRef();
  activeQueryLayer.current = getSelectedQueryLayer;

  useEffect(() => {
    if (!onZoneLaListFieldChange || onZoneLaListFieldChange === "select")
      return;

    const featureLayerUrl =
      getSelectedQueryLayer === "zone" ? ZONE_URL : LA_URL;
    navigateAndDisplayPopup(featureLayerUrl, onZoneLaListFieldChange).then(
      () => {
        setTimeout(function () {
          setZoneLaUniqueCode(null);
        }, 3000);
      }
    );

    return () => {
      /* clean up */
    };
  }, [
    navigateAndDisplayPopup,
    clearPopup,
    getSelectedQueryLayer,
    onZoneLaListFieldChange,
  ]);

  const triggerPopupAction = useCallback(() => {
    const { id } = QUERY_DATA_BUTTON_ACTION;
    triggerPopupActions(id, (actionAttributes) => {
      const { unique_code } = actionAttributes;
      const featureLayerUrl =
        activeQueryLayer.current === "zone" ? ZONE_URL : LA_URL;
      navigateAndDisplayPopup(featureLayerUrl, unique_code).then(() => {
        clearPopup();
        setTimeout(function () {
          setZoneLaUniqueCode(unique_code);
        }, 5000);
      });
    });
  }, [triggerPopupActions, navigateAndDisplayPopup, clearPopup]);

  useEffect(() => {
    triggerPopupAction();
    return () => {
      /* clean up */
    };
  }, [triggerPopupAction]);

  useEffect(() => {
    if (onQueryLayerFieldChange) {
      setZoneLaUniqueCode(null);
    }
  }, [onQueryLayerFieldChange]);

  const selectedZoneLaUniqueCode = useMemo(
    () => zoneLaUniqueCode,
    [zoneLaUniqueCode]
  );

  return {
    selectedZoneLaUniqueCode,
  };
};

export default useNavigateZoomToZoneLaPopup;
